import { useState } from "react";
import { searchReactivationCustomer } from "../../api/customer";

export default function CustomerSearchReactivation({ value, onChange }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const doSearchCustomer = async () => {
    const q = searchQuery.trim();
    if (!q) return;
    setSearchLoading(true);
    setNotFound(false);
    try {
      const { data } = await searchReactivationCustomer({ q });
      onChange(data.data);
      setSearchQuery("");
    } catch (error) {
      setNotFound(true);
    }
    setSearchLoading(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      doSearchCustomer();
    }
  };

  const clearSelected = () => {
    onChange(null);
    setSearchQuery("");
    setNotFound(false);
  };

  return (
    <div className="form-group">
      {!value ? (
        <>
          <label>Cari Pelanggan</label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Cari nomor pelanggan ..."
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              onKeyDown={handleKeyDown}
            />
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-primary"
                onClick={doSearchCustomer}
                disabled={searchLoading}
              >
                {searchLoading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-search"></i>
                )}
              </button>
            </div>
          </div>
          {notFound && <small className="text-danger">Pelanggan tidak ditemukan</small>}
        </>
      ) : null}

      {value && (
        <div className="card mt-3 border-left-info">
          <div className="card-body py-2">
            <div className="row">
              <div className="col">
                <strong>{value.name}</strong>
                <br />
                <small className="text-muted">{value.customer_number}</small>
              </div>
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={clearSelected}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
            <hr className="my-1" />
            <span>Alamat: {value.address}</span>
            <br />
            <div>
              Paket: <strong>{value.internet_package_name}</strong> <br />
              Telepon: {value.phone_number} <br />
              Status: <CustomerActiveBadge status={value.is_active} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function CustomerActiveBadge({ status }) {
  switch (status) {
    case 0:
      return <span className="badge badge-warning">Isolir</span>;
    case 1:
      return <span className="badge badge-success">Aktif</span>;
    case 2:
      return <span className="badge badge-danger">Dismantled</span>;
    case 3:
      return <span className="badge badge-success">Aktif Trial</span>;
    case 4:
      return <span className="badge badge-danger">Dismantle Trial</span>;
    default:
      return <></>;
  }
}
